// src/components/TabletSimulator.tsx
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import './TabletSimulator.scss';
import { FaCalculator, FaTv , FaChartBar} from 'react-icons/fa6';
import { MdOutlineTableRestaurant } from "react-icons/md";

type View = 'kds' | 'pos' | 'analytics' | 'layout';

const TabletSimulator: React.FC = () => {
  const [view, setView] = useState<View>('analytics');

  const renderKDS = () => {
    return(
    <div className="sim-screen-content">
        <img
          src={`${process.env.PUBLIC_URL}/web_page_images/KDS-mode.png`}
          alt="Modo Hoster"
          className="tablet-layout-view-img"
        />
    </div>
  )
  };

  const renderLayout = () => {
    return(
    <div className="sim-screen-content">
        <img
          src={`${process.env.PUBLIC_URL}/web_page_images/hoster-modeV2.png`}
          alt="Modo Hoster"
          className="tablet-layout-view-img small"
        />
    </div>
  )
  };
  const renderAnalytics = () => {
    return(
    <div className="sim-screen-content">
        <img
          src={`${process.env.PUBLIC_URL}/web_page_images/analytics.png`}
          alt="Modo Hoster"
          className="tablet-layout-view-img"
        />
    </div>
  )
  };
  const renderPOS = () => {
    return(
    <div className="sim-screen-content">
        <img
          src={`${process.env.PUBLIC_URL}/web_page_images/POS-mode.png`}
          alt="Modo Hoster"
          className="tablet-layout-view-img POS"
        />
    </div>
  )
  };

  return (
    <div className="tablet-simulator">
      <div className="view-selector">
        <Button variant="none" onClick={() => setView('analytics')} className={`selector-button ${view === 'analytics' ? 'active' : ''}`}>
            <FaChartBar/> Estadísticas
          </Button>
        <Button variant="none" onClick={() => setView('pos')} className={`selector-button ${view === 'pos' ? 'active' : ''}`}>
          <FaCalculator/> POS
        </Button>
        <Button variant="none" onClick={() => setView('kds')} className={`selector-button ${view === 'kds' ? 'active' : ''}`}>
          <FaTv/> KDS
        </Button>
        <Button variant="none" onClick={() => setView('layout')} className={`selector-button ${view === 'layout' ? 'active' : ''}`}>
        <MdOutlineTableRestaurant /> Vista salón
        </Button>
      </div>
      <div className="tablet-frame">
        <img
          src={`${process.env.PUBLIC_URL}/web_page_images/ipad.png`}
          alt="Tablet frame"
          className="tablet-img"
        />
        <div className="tablet-screen">
          {view === 'kds'      && renderKDS()}
          {view === 'pos'      && renderPOS()}
          {view === 'analytics' && renderAnalytics()}
          {view === 'layout'   && renderLayout()}
        </div>
      </div>


    </div>
  );
};

export default TabletSimulator;
